// Import Core
import React from "react";
import styled from "styled-components";
// Import Icons
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const FilterPaginationStyles = styled.ul`
  padding: var(--global-padding);
  /* padding-top: 0; */
  display: flex;
  width: fit-content;
  gap: 10px;
  list-style-type: none;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 768px) {
    padding: 0;
    justify-content: center;
    width: 100%;
    position: relative;
    height: 5.5rem;
  }
  li {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    &.pagination-arrow {
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 12px;
      @media (max-width: 768px) {
        position: absolute;
        bottom: 0;
      }
      &.prev-arrow {
        @media (max-width: 768px) {
          left: 16px;
        }
      }
      &.next-arrow {
        color: var(--blue);
        @media (max-width: 768px) {
          right: 16px;
        }
      }
      &.disabled {
        color: var(--black-50);
        cursor: not-allowed;
      }
    }
    &.pagination-counter {
      cursor: auto;
      @media (max-width: 768px) {
        position: absolute;
        top: 0;
      }
      span {
        padding: 14px;
        padding: 10px 0px;
        width: 40px;
        text-align: center;
        &:first-child {
          background-color: var(--red-25);
          color: var(--red);
        }
        &:last-child {
          background-color: var(--neutral-10);
        }
      }
      p {
        padding: 12px;
      }
    }
  }
`;

const scrollToTop = () => {
  window[`scrollTo`]({ top: 0, behavior: `smooth` });
};

const FilterPagination = ({ nPages, currentPage, setCurrentPage }) => {
  const nextPage = () => {
    if (currentPage !== nPages - 1) {
      setCurrentPage((prev) => Math.min(prev + 1, nPages - 1));
      scrollToTop();
    }
  };
  const prevPage = () => {
    if (currentPage !== 0) {
      setCurrentPage((prev) => Math.max(prev - 1, 0));
      scrollToTop();
    }
  };

  return (
    <FilterPaginationStyles>
      <li
        className={`pagination-arrow prev-arrow${
          currentPage === 0 ? " disabled" : ""
        }`}
        onClick={prevPage}
      >
        <FaChevronLeft />
        <span>PREVIOUS</span>
      </li>
      <li className="pagination-counter">
        <span>{currentPage + 1}</span>
        <p> of </p>
        <span>{nPages}</span>
      </li>
      <li
        className={`pagination-arrow next-arrow${
          currentPage === nPages - 1 ? " disabled" : ""
        }`}
        onClick={nextPage}
      >
        <span>NEXT</span>
        <FaChevronRight />
      </li>
    </FilterPaginationStyles>
  );
};

export default FilterPagination;
